import React from 'react';
import dynamic from 'next/dynamic';
import { RequestQuoteFormProps } from './RequestQuoteForm';
import { useTheme } from '@emotion/react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useDispatch } from 'react-redux';
import { ModalType, showModal } from '@state/modal/modalOperations';
import { FormikValues } from 'formik';
import { ContactForm, ContactFormErrors } from '@components/modal/form-error';

const RequestQuoteForm = dynamic(() => import('./RequestQuoteForm').then((e) => e.RequestQuoteFormComponent), {
  ssr: false
});

interface RequestQuoteFormContainerProps {
  testId?: string;
}

export const RequestQuoteFormContainer = (ownProps: RequestQuoteFormContainerProps) => {
  /* *** STATE *** */
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const onSubmitSuccess = () => dispatch(showModal(ModalType.FORM_SUBMIT_SUCCESS));
  const onSubmitError = () => dispatch(showModal(ModalType.FORM_SUBMIT_ERROR));

  const onSubmitInvalid = (values: FormikValues) => {
    const contactFormErrors: ContactFormErrors = {
      values,
      type: ContactForm.REQUEST_QUOTE
    };
    dispatch(showModal(ModalType.CONTACT_FORM_ERROR, contactFormErrors));
  };

  const props: RequestQuoteFormProps = {
    theme: useTheme(),
    onSubmitSuccess,
    onSubmitError,
    onSubmitInvalid,
    executeRecaptcha,
    ...ownProps
  };
  if (!executeRecaptcha) return null;
  return <RequestQuoteForm {...props} />;
};
